import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { FC } from 'react';

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  body: string;
  /** Label of the button that backs out and changes nothing. */
  keepLabel: string;
  /** Label of the button that goes through with it. */
  confirmLabel: string;
  onCancel: () => void;
  onConfirm: () => void;
}

/**
 * Asks before something irreversible - discarding an edit, deleting a step,
 * leaving a template with unsaved changes.
 */
export const ConfirmDialog: FC<ConfirmDialogProps> = ({
  open,
  title,
  body,
  keepLabel,
  confirmLabel,
  onCancel,
  onConfirm,
}) => (
  <Dialog open={open} onClose={onCancel} maxWidth="xs">
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      <DialogContentText>{body}</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel} size="small" variant="outlined">
        {keepLabel}
      </Button>
      <Button onClick={onConfirm} size="small" variant="contained" color="error">
        {confirmLabel}
      </Button>
    </DialogActions>
  </Dialog>
);
